import axios from "axios";
import { getProjections } from "../components/pages/Flotte/components/FlotteSimulator/simulatorUtils";
import { api_url } from "../config/config";
import { toast } from "react-toastify";

// Service pour gérer les appels API liés à la flotte de véhicules
const flotteService = {
  getFlotteList: async (params = {}) => {
    try {
      //remove spaces from params.immatriculations (array of strings)
      if (Array.isArray(params.immatriculations)) {
        params.immatriculations = params.immatriculations.map((immat) =>
          immat.replace(/\s/g, ""),
        );
      }
      console.log("params", params);
      const formattedFilters = {
        page: params.page || 1,
        immatriculations: params.immatriculations || "",
        client: params.client,
        marques: params.marques || "",
        modeles: params.modeles || "",
        finitions: params.finitions || "",
        statuts:
          params.statuts?.length > 0 ? params.statuts.map((p) => p + "") : "",
        contrat_date_debut: params.contrat_date_debut || "",
        contrat_date_fin: params.contrat_date_fin || "",
        commercial: params.commercial || "",
        catalogue: params.catalogue || "",
        date_prolongation: params.contrat_date_prolongation || "",
        date_vo: params.date_vo || "",
        date_facture: params.date_facture || "",
        anomalie_facturation: params.anomalie_facturation ? 1 : "",
        anomalie_depassement_kilometrique: params.anomalie_depassement_kilometrique
          ? 1
          : "",
        types_client:
          params.types_client?.length > 0
            ? params.types_client.map((t) => (t + "").toUpperCase())
            : [],
        derniere_date_retour: params.derniere_date_retour || "",
        date_dernier_statut: params.date_dernier_statut || "",
        carburants:
          params.carburants?.length > 0
            ? params.carburants.map((p) => p + "")
            : "",
        types_vehicule:
          params.types_vehicule?.length > 0
            ? params.types_vehicule.map((t) => (t + "").toUpperCase())
            : [],
        positions:
          params.positions?.length > 0
            ? params.positions.map((p) => p + "")
            : "",
      };

      const response = await axios.get(`${api_url}vehicules-flotte/lister`, {
        params: formattedFilters,
      });

      // Retourner les données brutes de l'API
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des véhicules de flotte:",
        error,
      );
      throw error;
    }
  },
  getFlotteListVO: async (params = {}) => {
    try {
      //remove spaces from params.immatriculations (array of strings)
      if (Array.isArray(params.immatriculations)) {
        params.immatriculations = params.immatriculations.map((immat) =>
          immat.replace(/\s/g, ""),
        );
      }
      console.log("params", params);
      const formattedFilters = {
        page: params.page || 1,
        contrat_date_debut: params.contrat_date_debut || "",
        contrat_date_fin: params.contrat_date_fin || "",
        immatriculations: params.immatriculations || "",
        client: params.client,
        marques: params.marques || "",
        modeles: params.modeles || "",
        finitions: params.finitions || "",
        statuts:
          params.statuts?.length > 0 ? params.statuts.map((p) => p + "") : "",
        date_vo: params.date_vo || "",
        date_facture: params.date_facture || "",
        derniere_date_retour: params.derniere_date_retour || "",
        date_dernier_statut: params.date_dernier_statut || "",
        carburants:
          params.carburants?.length > 0
            ? params.carburants.map((p) => p + "")
            : "",
        positions:
          params.positions?.length > 0
            ? params.positions.map((p) => p + "")
            : "",
      };

      const response = await axios.get(`${api_url}vehicules-flotte/lister-vo`, {
        params: formattedFilters,
      });

      // Retourner les données brutes de l'API
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des véhicules de flotte:",
        error,
      );
      throw error;
    }
  },

  getSimulationData: async ({ projection, item }) => {
    console.log("getSimulationData", projection);
    try {
      const response = await axios.post(
        `${api_url}vehicules-flotte/${item.id}/simuler`,
        { ...projection, champs_saisis: ["duree", "kilometrage"] },
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des données de simulation:",
        error,
      );
      throw error;
    }
  },

  updateCell: async ({ projection, item, modifiedField }) => {
    // LS-738 : l'erreur remonte à l'appelant (useFlotte.onUpdateCell), qui affiche le
    // message de l'API (409 : donnée figée par l'import) et ne touche pas à la ligne.
    const response = await axios.post(
      `${api_url}vehicules-flotte/${item.id}/recalculer-vo`,
      { ...projection, champ_saisi: modifiedField },
    );
    return { ...projection, ...response.data };
  },

  // LS-738 : lève le verrou de facturation (super admin). Renvoie la ligne VO à jour.
  deverrouillerFacturation: async ({ item }) => {
    const response = await axios.post(
      `${api_url}vehicules-flotte/${item.id}/deverrouiller-facturation`,
    );
    return response.data;
  },

  // LS-742 : les causes de l'anomalie de facturation sont portées par le véhicule (pas par la
  // ligne VO renvoyée par recalculer-vo / deverrouiller-facturation) : on les relit après une
  // saisie pour que le marqueur suive ce que l'utilisateur vient de corriger.
  getAnomaliesFacturation: async ({ item }) => {
    const response = await axios.get(`${api_url}vehicules-flotte/${item.id}`);
    return response.data?.anomalies_facturation ?? [];
  },

  updateProjection: async ({ projection, item, modifiedField }) => {
    console.log("updateProjection", projection);
    console.log("item", item);
    console.log("modifiedField", modifiedField);

    try {
      const response = await axios.post(
        `${api_url}vehicules-flotte/${item.id}/recalculer`,
        { ...projection, champ_saisi: modifiedField },
      );
      console.log("response", response.data);
      return { ...projection, ...response.data };
    } catch (error) {
      toast.error("Erreur lors de la mise à jour de la projection");
      return projection;
    }
  },
  // Édition d'une cellule du sous-tableau RME (Fin réelle).
  // Envoie les 9 champs RME (devis/définitif/facturé pour km_sup, indemnités,
  // frais RME) à l'endpoint dédié — pas de routage via /recalculer.
  renseignerFraisFinReelle: async ({ projection, item }) => {
    const payload = {
      projection_id: projection.id,
      frais_remise_en_etat_devis: projection.frais_remise_en_etat_devis ?? null,
      frais_remise_en_etat_definitif:
        projection.frais_remise_en_etat_definitif ?? null,
      frais_remise_en_etat_facture:
        projection.frais_remise_en_etat_facture ?? null,
      indemnites_devis: projection.indemnites_devis ?? null,
      indemnites_definitif: projection.indemnites_definitif ?? null,
      indemnites_facture: projection.indemnites_facture ?? null,
      montant_km_supp_devis: projection.montant_km_supp_devis ?? null,
      montant_km_supp_definitif: projection.montant_km_supp_definitif ?? null,
      montant_km_supp_facture: projection.montant_km_supp_facture ?? null,
    };
    try {
      const response = await axios.post(
        `${api_url}vehicules-flotte/${item.id}/renseigner-frais-fin-reelle`,
        payload,
      );
      return { ...projection, ...response.data };
    } catch (error) {
      toast.error("Erreur lors de la mise à jour des frais de fin réelle");
      return projection;
    }
  },
  initializeProjections: (item) => {
    const projections = getProjections(item);
    console.log("initializeProjections", projections);
    return projections;
  },

  getSimulationCalculatedValues: async ({ items, modifiedField }) => {
    console.log("getSimulationCalculatedValues", items, modifiedField);
  },
  getSimuationExternalValues: async (item) => {
    console.log("getSimuationExternalValues", item);
    return {};
  },
  addCommentaire: ({ commentaire, item }) => {
    console.log("addCommentaire", commentaire, item);
    return axios.post(`${api_url}vehicules-flotte/${item.id}/commenter`, {
      commentaire,
    });
  },
  addStatut: async ({ statut, item }) => {
    console.log("addStatut", statut, item);
    try {
      // Appel de la route pour modifier le statut
      await axios.post(
        `${api_url}vehicules-flotte/${item.id}/modifier-statut`,
        {
          statut,
        },
      );

      // Récupération des données mises à jour du véhicule
      const response = await axios.get(`${api_url}vehicules-flotte/${item.id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la modification du statut:", error);
      throw error;
    }
  },

  addPosition: async ({ position, item }) => {
    console.log("addPosition", position, item);
    try {
      await axios.post(
        `${api_url}vehicules-flotte/${item.id}/modifier-position`,
        {
          position,
        },
      );

      const response = await axios.get(`${api_url}vehicules-flotte/${item.id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la modification de la position:", error);
      throw error;
    }
  },

  modifierSecteur: async ({ secteur, item }) => {
    console.log("modifierSecteur", secteur, item);
    try {
      await axios.post(
        `${api_url}vehicules-flotte/${item.id}/modifier-secteur`,
        {
          secteur,
        },
      );

      const response = await axios.get(`${api_url}vehicules-flotte/${item.id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la modification du secteur:", error);
      throw error;
    }
  },

  modifierSecteurEnMasse: async ({ vehiculeIds, secteur }) => {
    console.log("modifierSecteurEnMasse", vehiculeIds, secteur);
    try {
      const response = await axios.post(
        `${api_url}vehicules-flotte/modifier-secteur-en-masse`,
        {
          vehicules: vehiculeIds,
          secteur,
        },
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la modification en masse du secteur:",
        error,
      );
      throw error;
    }
  },

  addLocalisation: async ({ localisation, item }) => {
    console.log("addLocalisation", localisation, item);
    try {
      await axios.post(
        `${api_url}vehicules-flotte/${item.id}/modifier-localisation`,
        {
          localisation,
        },
      );

      const response = await axios.get(`${api_url}vehicules-flotte/${item.id}`);
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la modification de la localisation:",
        error,
      );
      throw error;
    }
  },

  resetPosition: async ({ item }) => {
    console.log("resetPosition", item);
    try {
      await axios.patch(
        `${api_url}vehicules-flotte/${item.id}/reinitialiser-position`,
      );

      const response = await axios.get(`${api_url}vehicules-flotte/${item.id}`);
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la réinitialisation de la position:",
        error,
      );
      throw error;
    }
  },

  listImportsFactures: async () => {
    try {
      const response = await axios.get(
        `${api_url}vehicules-flotte/factures/import/lister`,
      );
      return response.data;
    } catch (error) {
      console.error(
        "Erreur lors de la récupération de l'historique des imports:",
        error,
      );
      throw error;
    }
  },

  importFactures: async (file) => {
    try {
      const formData = new FormData();
      formData.append("fichier", file);

      const response = await axios.post(
        `${api_url}vehicules-flotte/factures/import`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" },
          validateStatus: (status) => status === 200 || status === 207,
        },
      );

      return {
        status: response.status,
        data: response.data,
      };
    } catch (error) {
      console.error("Erreur lors de l'import des factures:", error);
      throw error;
    }
  },
};

export default flotteService;
